import classnames from 'classnames';
import React from 'react';

import { ScheduleElement } from '../../graphql/components';
import { formatScheduleElementRGBAColor, getContrastColor, getTextShadowOfScheduleElement } from '../../utils/chart';

import type { CustomLabelProps } from '../../components/Inputs/SelectField';

type ScheduledActivityLabelProps = CustomLabelProps & {
  className?: string;
  element: ScheduleElement;
};

export const ScheduledActivityLabel: React.FC<ScheduledActivityLabelProps> = ({
  className,
  element: { color, id },
  label,
}) => {
  const contrastColor = getContrastColor(color);

  return (
    <div
      className={classnames('select-scheduled-activity__item-label', className)}
      data-test-id={`select-custom-label-${id}`}
      style={{
        backgroundColor: formatScheduleElementRGBAColor(color),
        color: formatScheduleElementRGBAColor(contrastColor),
        textShadow: getTextShadowOfScheduleElement(contrastColor),
      }}
    >
      {label}
    </div>
  );
};
